import { Popover } from '@atgfr8/atg-ui-tailwind';
import { JSXElement, Show, createSignal } from 'solid-js';

export const HoverPopInline = (props: {
  children: JSXElement;
  anchor: JSXElement;
  render: boolean;
}) => {
  //Popover Boilerplate
  const [anchorEl, setAnchorEl] = createSignal<HTMLButtonElement | null>(null);
  const open = () => Boolean(anchorEl());
  const handleHover = (
    event: MouseEvent & { currentTarget: HTMLButtonElement },
  ) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //Popover Boilerplate
  return (
    <>
      <button
        class="bg-none border-none p-0 text-armstrong-blue underline cursor-default"
        type="button"
        onMouseEnter={handleHover}
        onMouseLeave={handleClose}
      >
        {props.anchor}
      </button>
      <Show when={props.render}>
        <Popover
          open={open()}
          sx={{ 'pointer-events': 'none' }}
          disableRestoreFocus
          anchorEl={anchorEl()}
          onClose={handleClose}
          dataTestId="hover-pop-inline-popover"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {props.children}
        </Popover>
      </Show>
    </>
  );
};
